import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';
import { Monitors } from './types';

interface GetMonitorsByUnit {
  monitors: Monitors[];
}
export const getMonitorsListUnit = async (unitId: string): Promise<AxiosResponse<GetMonitorsByUnit>> =>
  AxiosInstance.get(`livechat/units/${unitId}/monitors`);
